import PropTypes from "prop-types";
export default PropTypes.shape({
  value: PropTypes.object,
  errors: PropTypes.object,
  setFieldValue: PropTypes.func,
  handleSubmit: PropTypes.func,
});
